import { Controller } from 'stimulus';
import gsap from 'gsap';
import dataItems from './scrollanimations/data-items';
import textImac from './scrollanimations/text-imac';

const observersSupported = () => (
  'IntersectionObserver' in window
  && 'classList' in document.createElement('p')
);

const scrollAnimationCallbacks = {
  dataItems,
  textImac,
};

class ScrollAnimation extends Controller {
  connect() {
    this.animationElement = this.element.firstElementChild;

    if (this.animationElement && observersSupported()) {
      this.animationElement.style.opacity = 0;

      this.buildObservers();
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  buildObservers() {
    const windowHeight = window.innerHeight;

    let rootMarginOffset = (windowHeight / 10) * -1;

    if (this.data.get('offset')) {
      rootMarginOffset = parseInt(this.data.get('offset'), 10);
    }

    const config = {
      root: null,
      rootMargin: `0px 0px ${rootMarginOffset}px 0px`,
      threshold: [0, 1],
    };

    this.observer = new IntersectionObserver(
      this.onObserverChange.bind(this),
      config,
    );

    this.observer.observe(this.element);
  }

  animateElement() {
    gsap.to(this.animationElement, {
      opacity: 1,
    });
  }

  callCallback(isIntersecting) {
    if (this.data.get('callback')) {
      const callbackName = this.data.get('callback');

      if (typeof scrollAnimationCallbacks[callbackName] === 'function') {
        scrollAnimationCallbacks[callbackName](this.element, isIntersecting);
      }
    }
  }

  onObserverChange(changes) {
    changes.forEach((change) => {
      if (!change.isIntersecting) {
        this.callCallback(false);
        return;
      }

      if (!this.animationElement.classList.contains('is-animated')) {
        this.animateElement();
        this.animationElement.classList.add('is-animated');
      }

      this.callCallback(true);
    });
  }
}

ScrollAnimation.targets = [
  //
];

export default ScrollAnimation;
